<div class="page-wrapper section-hr-direct">
    <app-left-menu [showMenu]="false"></app-left-menu>

    <div id="main-container">

        <app-header [showHistoryButton]="true" [title]="title"></app-header>
        <div style="height: 40px;display: block;">&nbsp;</div>
        <div class="page-content">

            <a [routerLink]="['licenses']" class="panel-link ">{{'Common.License'|translate}}
                <span>
                    <!--Batch for Benefit Notifications-->

                    <i class="license-badge "></i>
                </span>
            </a>
            <a [routerLink]="['liabilities']" class="panel-link ">{{'Common.Liability'|translate}}
                <span>
                    <!--Batch for Benefit Notifications-->

                    <i class="liability-badge "></i>
                </span>
            </a>



            <div class="legend-warning" style=" display: none;   margin-left: 40px;">
                <i class="licenseandliability legend-warning-badge" style="display: inline-block;"></i>
                <label>{{'Common.WarningBadgeMessage'|translate}}</label></div>
            <div class="legend-alert" style=" display: none;  margin-top:20px; margin-left: 40px;">
                <i class="licenseandliability legend-alert-badge" style="display: inline-block;"></i>
                <label>{{'Common.AlertBadgeMessage'|translate}}</label></div>


        </div>
    </div>